import axios from 'axios';

const BASE_URL = process.env.VUE_APP_API_URL;

class api {
  constructor() {
    this._request = axios;
  }

  request(method, url, data = null) {
    return new Promise(async resolve => {
      let headers = {};

      try {
        const response = await this._request({
          method,
          url: `${BASE_URL}${url}`,
          headers,
          data
        });

        return resolve(response);
      } catch (error) {
        if (error.response && error.response.data) {
          console.warn(error.response.data) //eslint-disable-line
        } else {
          console.error(error) //eslint-disable-line
        }
        return resolve({ error });
      }
    });
  }

  alcafozenseValidate(token) {
    return this.request('get', `/alcafozense/validate/${token}`);
  }

  alcafozenseLogin(password) {
    return this.request('get', `/alcafozense/login/${password}`);
  }

  alcafozenseList(token) {
    return this.request('get', `/alcafozense/list/${token}`);
  }

  mediaDirectories() {
    return this.request('get', '/media/list')
  }

  mediaList(type, folder) {
    return this.request('get', `/media/${type}/${encodeURIComponent(folder)}`)
  }

  getNameList(type, name) {
    return this.request('get', `/${type}/search/${encodeURIComponent(name)}`)
  }

  registerAccess(identifier) {
    return this.request('post', `/analytics/register-access/user`, { identifier }, true)
  }
}

const vueApi = {
  install: (Vue) => {
    Vue.prototype.$api = new api();
  }
}

export default vueApi;
